import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { AppRoutes, OmRolesEnum } from '@shared/enums';

export const centralShippingGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const currentUserService = inject(CurrentUserService);
    await currentUserService.initializeCurrentUser();

    if (!currentUserService.hasRole(OmRolesEnum.CENTRAL_SHIPPING_ADMINISTRATOR)) {
        router.navigate([AppRoutes.DASHBOARD]);
        return false;
    }

    return true;
};
